(() => {
  if (window.pkSharedTableReady) return;
  window.pkSharedTableReady = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const observed = new WeakSet();
  const animations = new Set();
  let observer;
  const allowed = root => !reduced.matches && document.body.dataset.pkMotion === 'true' && root.dataset.motion === 'true' && !window.Shopify?.designMode;
  function enter(root) {
    if (!allowed(root)) return;
    const line = root.querySelector('.pk-table__rule');
    const detail = root.querySelector('.pk-table__detail');
    const tracks = [];
    if (line) tracks.push(line.animate([{clipPath:'inset(0 75% 0 0)'},{clipPath:'inset(0 0 0 0)'}], {duration:650,easing:'cubic-bezier(.2,.65,.2,1)'}));
    if (detail && getComputedStyle(detail).display !== 'none') tracks.push(detail.animate([{translate:'0 12px'},{translate:'0 0'}],{duration:600,easing:'cubic-bezier(.2,.65,.2,1)'}));
    tracks.forEach(animation => {animations.add(animation);animation.finished.catch(()=>{}).finally(()=>animations.delete(animation));});
  }
  function init(scope=document) {
    scope.querySelectorAll('[data-pk-table]').forEach(root => {
      if(observed.has(root)) return;
      observed.add(root);
      if(!allowed(root) || !('IntersectionObserver' in window)) return;
      if(!observer) observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){observer.unobserve(entry.target);enter(entry.target);}}),{threshold:.08});
      observer.observe(root);
    });
  }
  reduced.addEventListener('change',()=>{if(reduced.matches){animations.forEach(animation=>animation.cancel());animations.clear();}});
  document.addEventListener('shopify:section:load',event=>init(event.target));
  init();
})();
